import React from 'react'
import {FlexibleXYPlot, XYPlot, HorizontalGridLines, LineSeries, XAxis, YAxis} from 'react-vis';
import 'react-vis/dist/style.css';
 
function Graph() {
    const data = [
        {x: 0, y: 8},
        {x: 1, y: 5},
        {x: 2, y: 4},
        {x: 3, y: 9},
        {x: 4, y: 1},
        {x: 5, y: 7},
        {x: 6, y: 6},
        {x: 7, y: 3},
        {x: 8, y: 2},
        {x: 9, y: 0}
      ];
      return (
        /*<div>
          <XYPlot width={700} height={350}>
            <LineSeries data={data} />
            <XAxis title="Time" />
            <YAxis title = "Profit"/>
          </XYPlot>
        </div> */
        <div>
        <FlexibleXYPlot height={400}>
          <HorizontalGridLines />
          <LineSeries data={data} />
          <XAxis title="Time" />
          <YAxis title = "Profit"/>
        </FlexibleXYPlot>
      </div>
      );
}
export default Graph